import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SimpleVehicleManagementModuleFooter = () => {
    const { t } = useTranslation(['simpleVehicleManagementDetail']);

    return (
        <Button form="updateForm" htmlType="submit" type="primary">
            {t('simpleVehicleManagementDetail:mainActionButtons.update')}
        </Button>
    );
};

export default SimpleVehicleManagementModuleFooter;
